import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: "app-text-area-input",
    templateUrl: "./text-area-input.component.html",
    styleUrls: ["./text-area-input.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextAreaInputComponent),
            multi: true,
        },
    ],
})
export class TextAreaInputComponent implements ControlValueAccessor {
    @Input() labelText: string;
    @Input() options: string;
    @Input() placeholder = "";
    @Input() customClass?: string = "";
    @Input() customErrorClass?: string;
    @Input() invalid? = false;
    @Input() autoFocus?: boolean;
    @Input() rows?: number = 2;
    @Input() maxChars?: number;
    @Input() disabled = false;

    constructor() { }

    onChange: any = () => { };
    onTouch: any = () => { };
    val = ""; // this is the updated value that the class accesses

    set value(val) {  // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
        this.val = val;
        this.onChange(val);
        this.onTouch(val);
    }

    // this method sets the value programmatically
    writeValue(value: any) {
        this.value = value;
    }
    // upon UI element value changes, this method gets triggered
    registerOnChange(fn: any) {
        this.onChange = fn;
    }
    // upon touching the element, this method gets triggered
    registerOnTouched(fn: any) {
        this.onTouch = fn;
    }

}
